import request from '@/utils/requestnew'
import baseUrl from './baseUrl'

const BASE_URL = baseUrl + '/area'

export default {
    //列表接口
    findAll() {
        return request({
            url: BASE_URL + '/findAll',
            method: 'get'
        })
    },
    findSearch(page,size,searchMap) {
        return request({
            url: `findSearch/${page}/${size}`,
            method: 'post',
            data: searchMap
        })
    },
    add(data){
        return request({
            url: BASE_URL + '/add',
            method: 'post',
            data
        })
    },
    handleDelete(id){
        return request({
            url: BASE_URL + `/handleDelete/${id}`,
            method: 'get'
        })
    },
    findById(id){
        return request({
            url: BASE_URL + `/findById/${id}`,
            method: 'get'
        })
    },
    update(entity){
        return request({
            url: BASE_URL + '/update',
            method: 'post',
            data: entity
        })
    },
}